// Shared FOMO / availability indicator helpers (Update 17).
// Indicators describe how a date/slot cell looks at a given fill %.

export const DEFAULT_FOMO_INDICATORS = [
  { id: "available", label: "Available", threshold: null, fixed: true, label_color: "#22c55e", cell_bg_color: "#22c55e", cell_bg_opacity: 15, cell_border_color: "#22c55e" },
  { id: "1", label: "Selling Fast", threshold: 50, label_color: "#eab308", cell_bg_color: "#eab308", cell_bg_opacity: 20, cell_border_color: "#eab308" },
  { id: "2", label: "Nearly Gone", threshold: 75, label_color: "#f97316", cell_bg_color: "#f97316", cell_bg_opacity: 20, cell_border_color: "#f97316" },
  { id: "3", label: "Sold Out", threshold: 100, label_color: "#dc2626", cell_bg_color: "#dc2626", cell_bg_opacity: 20, cell_border_color: "#dc2626" },
];

export const DEFAULT_SLOT_FOMO_INDICATORS = [
  { id: "available", label: "Available", threshold: null, fixed: true, label_color: "#22c55e", cell_bg_color: "#22c55e", cell_bg_opacity: 15, cell_border_color: "#22c55e" },
  { id: "1", label: "Filling Up", threshold: 50, label_color: "#eab308", cell_bg_color: "#eab308", cell_bg_opacity: 15, cell_border_color: "#eab308" },
  { id: "2", label: "Nearly Full", threshold: 75, label_color: "#f97316", cell_bg_color: "#f97316", cell_bg_opacity: 15, cell_border_color: "#f97316" },
  { id: "3", label: "Full", threshold: 100, label_color: "#dc2626", cell_bg_color: "#dc2626", cell_bg_opacity: 15, cell_border_color: "#dc2626" },
];

// Backfill the four colour fields from a legacy single `color` value if needed.
export function normInd(i) {
  if (!i) return null;
  const c = i.color || "#9ca3af";
  return {
    ...i,
    label_color: i.label_color || c,
    cell_bg_color: i.cell_bg_color || c,
    cell_bg_opacity: i.cell_bg_opacity ?? 15,
    cell_border_color: i.cell_border_color || c,
  };
}

export function rgbaFromHex(hex, opacityPct) {
  const s = String(hex || "").replace("#", "");
  if (s.length !== 6) return hex || "transparent";
  const r = parseInt(s.slice(0, 2), 16);
  const g = parseInt(s.slice(2, 4), 16);
  const b = parseInt(s.slice(4, 6), 16);
  const a = opacityPct == null ? 1 : Math.max(0, Math.min(100, opacityPct)) / 100;
  return `rgba(${r}, ${g}, ${b}, ${a})`;
}

// Ensures the baseline "Available" indicator is always the fixed default with a
// null threshold (shown until the first real urgency threshold is crossed).
// Self-heals legacy data where "available" was saved as a 1% thresholded row.
export function normalizeIndicators(list) {
  const arr = (list || []).map((x) => ({ ...x }));
  if (!arr.length) return arr;
  let baseIdx = arr.findIndex((x) => x.id === "available" || x.fixed);
  if (baseIdx < 0) baseIdx = 0;
  arr[baseIdx] = { ...arr[baseIdx], fixed: true, threshold: null };
  return arr;
}

// Returns the indicator that applies to a fill % (0–100), or the fixed/base one.
export function matchIndicator(indicators, fillPct) {
  const norm = normalizeIndicators(indicators);
  const thresholded = norm.filter((i) => i.threshold != null).sort((a, b) => b.threshold - a.threshold);
  for (const i of thresholded) if (fillPct >= i.threshold) return i;
  return norm.find((i) => i.threshold == null) || null;
}

export function indicatorCellStyle(ind) {
  const n = normInd(ind);
  if (!n) return undefined;
  return {
    background: rgbaFromHex(n.cell_bg_color, n.cell_bg_opacity),
    borderColor: n.cell_border_color,
    color: n.label_color,
  };
}

export function newIndicatorId() {
  return (typeof crypto !== "undefined" && crypto.randomUUID) ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2, 6)}`;
}
